<template>
	<div class="campusIdDetail">

		<div class="breadcrumb">找回学号
			<span>
				<el-button class="right_f" type="primary" @click="cancel">返回</el-button>
				<el-button class="right_f" type="primary" @click="disagree" v-if="campusIdfb.status == '1'">不通过</el-button>
				<el-button class="right_f" type="primary" @click="agree" v-if="campusIdfb.status == '1'">通过</el-button>
			</span>
		</div>

		<div>
			<el-form ref="articleForm" :model="campusIdfb" label-width="120px">

				<el-form-item label="姓名">
					<el-input v-model="campusIdfb.name" disabled></el-input>
				</el-form-item>

				<el-form-item label="手机号">
					<el-input v-model="campusIdfb.phone" disabled></el-input>
				</el-form-item>

				<el-form-item label="学校">
					<el-input v-model="campusIdfb.school" disabled></el-input>
				</el-form-item>

				<el-form-item label="申请学号">
					<el-input v-model="campusIdfb.campusId" disabled></el-input>
				</el-form-item>

				<el-form-item label="学生证照片" style="margin-bottom:-10px;">
					<img style="height: 190px;margin-right:10px;cursor:pointer;" :src="campusIdfb.imgUrl1" v-if="campusIdfb.imgUrl1" @click="clickImg($event)">
					<img style="height: 190px;cursor:pointer;" :src="campusIdfb.imgUrl2" v-if="campusIdfb.imgUrl2" @click="clickImg($event)">
					<big-img v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc" :name='campusIdfb.name' :school="campusIdfb.school" :campusId="campusIdfb.campusId"
					 class="bigImg"></big-img>
				</el-form-item>
				<el-form-item>
					<span v-if="campusIdfb.imgUrl1 || campusIdfb.imgUrl2" class="tips">双击查看大图</span>
				</el-form-item>
			</el-form>
		</div>

	</div>
</template>
<script>
	import BigImg from "./BigImg.vue";

	export default {
		data() {
			return {
				id: "",
				keyType: "",
				keyword: "",
				status: "",
				campusIdfb: {
					name: "",
					phone: "",
					campusId: "",
					school: "",
					status: "1",
					imgUrl1: "",
					imgUrl2: ""
				},
				showImg: false,
				imgSrc: ""
			};
		},
		mounted() {
			this.id = this.$util.getUrlParam("id");
			this.keyType = this.$util.getUrlParam("keyType");
			this.keyword = this.$util.getUrlParam("keyword");
			this.status = this.$util.getUrlParam("status");

			this.getDetail();
		},
		components: {
			"big-img": BigImg
		},
		methods: {
			cancel() {
				let params = {
					status: this.status,
					pageNum: this.$util.getUrlParam("pageNum"),
					keyType: this.keyType,
					keyword: encodeURI(this.keyword.trimLeft())
				}
				this.$util.refreshTo("#/userM/campusIdManage", params);
			},
			clickImg(e) {
				this.showImg = true;
				// 获取当前图片地址
				this.imgSrc = e.currentTarget.src;
			},
			viewImg() {
				this.showImg = false;
			},
			/** 获取找回学号的详情**/
			getDetail() {
				let url = this.$util.domain + "/adminapi/v3/user/campusidfindback/detail";
				this.$http({
					url,
					method: "POST",
					body: JSON.stringify({ id: this.id * 1 })
				}).then((response) => {
					if (response.data.error == 10000) {
						this.campusIdfb = response.data.data;
					} else {
						this.$util.errorMsg(response.data.message);
					}
				});
			},
			/** 同意找回 **/
			agree() {
				let url = this.$util.domain + "/adminapi/v3/user/campusidfindback/agree";
				this.$confirm("确定通过" + this.campusIdfb.name + "的学号找回吗？", "温馨提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消"
				}).then(() => {
					this.$http({
						url,
						method: "POST",
						body: JSON.stringify({
							id: this.id * 1
						})
					}).then((response) => {
						if (response.data.error == 10000) {
							this.$util.successMsg("操作成功");
							this.cancel();
						} else {
							this.$util.errorMsg(response.data.message);
						}
					});
				}).catch(() => { });
			},
			//不同意找回
			disagree() {
				let url = this.$util.domain + "/adminapi/v3/user/campusidfindback/disagree";
				this.$confirm("确定不通过" + this.campusIdfb.name + "的学号找回吗？", "温馨提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消"
				}).then(() => {
					this.$http({
						url,
						method: "POST",
						body: JSON.stringify({
							id: this.id * 1
						})
					}).then((response) => {
						if (response.data.error == 10000) {
							this.$util.successMsg("操作成功");
							this.cancel();
						} else {
							this.$util.errorMsg(response.data.message);
						}
					});
				}).catch(() => { });
			}
		}
	};
</script>
<style scoped>
	.campusIdDetail {
		height: 100%;
		min-height: 1180px;
		overflow: scroll;
	}

	.campusIdDetail .el-select {
		display: inline-block;
	}

	.campusIdDetail .el-input {
		display: inline-block;
		width: 25%;
	}

	.campusIdDetail .el-button {
		display: inline-block;
	}

	.campusIdDetail .el-button+.el-button {
		margin-left: 0;
	}

	.campusIdDetail .panel {
		height: 90px;
	}

	.campusIdDetail .title {
		display: inline-block;
		width: 140px;
		text-align: right;
	}

	.campusIdDetail .tips {
		font-weight: bold;
	}

	.search {
		margin-left: 30px;
	}

	.datas {
		margin-top: 20px;
	}

	.el-dialog__body p {
		line-height: 38px;
	}
</style>


// WEBPACK FOOTER //
// campusIdDetail.vue?4267c443